<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <h5>Send Incident Report - ID: {{ this.incidentId }}</h5>
        <hr />
        <form @submit.prevent="reportIncident">
          <div class="row">
            <div class="col-6 mb-3">
              <label>Vehicle Number</label>
              <input
                name="vehicleNumber"
                placeholder="Vehicle Plate Number"
                type="text"
                class="form-control"
                v-model="vehicleNumber"
                maxlength="10"
                style="text-transform: uppercase"
                required
              />
            </div>
            <div class="col-6 mb-3">
              <label>Driver Name</label>
              <input
                name="driverName"
                placeholder="Driver Name"
                type="text"
                class="form-control"
                v-model="driverName"
                required
              />
            </div>
            <div class="col-6 mb-3">
              <label>No. of Injured People</label>
              <input
                placeholder="No. of Injured People"
                type="number"
                class="form-control"
                v-model="injuredCount"
                required
              />
            </div>
            <div class="col-6 mb-3">
              <label>Incident Images</label>
              <file-pond
                ref="pond"
                label-idle="Attach Incident Images"
                :allow-multiple="true"
                accepted-file-types="image/jpeg, image/png"
                max-files="6"
                :files="myFiles"
                :credits="credits"
                imagePreviewMaxHeight="70"
              />
            </div>
            <hr />
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-danger me-1 w-50">
                Report Incident <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import Swal from "sweetalert2";
import incidentMixin from "@/mixins/incident";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  mixins: [incidentMixin],
  props: {
    incidentId: String,
  },
  components: {
    Layout,
    FilePond,
  },
  data() {
    return {
      selectedIncident: {},
      vehicleNumber: null,
      driverName: null,
      injuredCount: null,
      myFiles: [],
      credits: "",
    };
  },
  mounted() {
    this.sockets.subscribe("GET_INCIDENT_BY_ID", (data) => {
      this.selectedIncident = data[0];
    });

    this.$socket.emit(
      "REQUEST:GET_INCIDENT_BY_ID",
      JSON.stringify({ incidentId: this.incidentId })
    );
  },
  methods: {
    async reportIncident() {
      try {
        const body = {
          id: this.selectedIncident.id,
          vehicle_no: this.vehicleNumber,
          driver_name: this.driverName,
          injured_count: this.injuredCount,
        };

        await this.ReportIncident(body);

        Swal.fire(
          "Report Saved",
          "Report has been saved for this incident",
          "success"
        ).then(() => {
          this.$router.push("/tablet/dashboard");
        });
      } catch (e) {
        Swal.fire("Failed", "Failed to save report", "error");
      }
    },
  },
};
</script>
<style>
.filepond--root {
  font-family: "Poppins", sans-serif;
}

.filepond--panel-root {
  background-color: #2a3042;
}

.filepond--drop-label {
  color: #a6b0cf;
  font-size: 10px;
}

textarea::placeholder,
input::placeholder {
  color: #717174 !important;
}

.vs__search::placeholder,
.vs__dropdown-toggle,
.vs__selected,
.vs__dropdown-menu {
  background: #2a3042;
  border: none;
  color: #a6b0cf;
  font-size: 13px;
}

.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected .vs--disabled::placeholder {
  background-color: #1a2031;
  color: #1a2031;
}

.vs__disabled-bg {
  background: #333f78;
}

.vs__clear,
.vs__open-indicator {
  fill: #394066;
}

@media (min-width: 30em) {
  .filepond--item {
    width: calc(50% - 0.5em);
  }
}

@media (min-width: 50em) {
  .filepond--item {
    width: calc(16.66% - 0.5em);
  }
}
</style>
